// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1slF7","label":"styles_label__3bA7B"};